// App.jsx / App.tsx

import React, { Component } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const editorConfiguration = {
    toolbar: ['undo', 'redo', 'heading', 'bold', 'italic', 'numberedList', 'bulletedList', 'link']
};

const Editor = ({ data, setData }) => {
    return (
        <div style={{ marginTop: '20px' }}>

            <CKEditor
                editor={ClassicEditor}
                config={editorConfiguration}
                data={data || ""}
                // onReady={editor => {
                //     // You can store the "editor" and use when it is needed.
                //     console.log('Editor is ready to use!', editor);
                // }}
                onChange={(event, editor) => {
                    console.log('change', event, editor.data.get());
                    setData(editor.data.get())
                }}
            // onBlur={(event, editor) => {
            //     console.log('Blur.', editor);
            // }}
            // onFocus={(event, editor) => {
            //     console.log('Focus.', editor);
            // }}
            />
        </div>
    );

}

export default Editor;
